import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ScheduleFlow from 'components/Flows/ScheduleFlows/ScheduleFlows';
import ScheduleAnalysisDrawer from 'components/Analyses/ScheduleAnalyses/Drawer/Drawer';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const ScheduleFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <ScheduleAnalysisDrawer />
      <ScheduleFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ScheduleFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);